var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_684_4009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9506 1.05C16.2756 0.375 15.3756 0 14.4006 0C13.4256 0 12.5256 0.375 11.8506 1.05L1.80061 11.1C1.72561 11.175 1.65061 11.325 1.65061 11.4L0.000614271 17.1C-0.0743857 17.325 0.000614267 17.625 0.150614 17.775C0.375614 17.925 0.525614 18 0.675614 18C0.750614 18 0.825614 18 0.900614 18L6.60061 16.35C6.82561 16.275 7.05061 16.125 7.12561 15.825C7.20061 15.6 7.12561 15.3 6.97561 15.15L3.37561 11.55L11.6256 3.225L14.7006 6.3L8.32561 12.75C8.02561 13.05 8.02561 13.5 8.32561 13.725C8.62561 14.025 9.07561 14.025 9.30061 13.725L16.9506 6.15C17.6256 5.475 18.0006 4.575 18.0006 3.6C18.0006 2.625 17.6256 1.725 16.9506 1.05ZM5.02561 15.3L1.72561 16.275L2.62561 12.9L5.02561 15.3ZM15.9756 5.175L15.7506 5.325L12.6756 2.25L12.9006 2.025C13.3506 1.575 13.8756 1.35 14.4756 1.35C15.0756 1.35 15.6006 1.575 16.0506 2.025C16.5006 2.475 16.7256 3 16.7256 3.6C16.7256 4.2 16.3506 4.725 15.9756 5.175Z",
    fill: "#6483A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_4009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActivity);
export default __webpack_public_path__ + "static/media/EditActivity.7a1c1e41da99dcc1989b052ba401db50.svg";
export { ForwardRef as ReactComponent };